import { IUserModel } from '../models/user.model';

export function canManageUserCompetences(
  user: IUserModel | undefined,
  tenantId: string | undefined,
  userId: string | undefined
): boolean {
  if (!user?.isActive || user.deleted || !tenantId || user.id !== userId) {
    return false;
  }

  return user.belongsToTenants.some(
    (item) => item.tenant.id === tenantId && !item.deleted && !item.isPaused
  );
}
